var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'extra-icon': true,
    'extra-icon-off': !this.on,
    'text-primary': this.on,
    'text-gray': !this.on
  },on:{"click":function($event){return _vm.handleClick($event)}}},[_c('Icon',{attrs:{"name":_vm.name,"size":"22"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }